import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {Toaster} from './toaster.model';

export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  DANGER = 'danger',
  ALERT = 'alert',
  INFO = 'info',
  WARNING = 'warning'
}

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor() {
  }

  private subject = new Subject<Toaster>();
  private defaultId = 'default';


  onToast(id = this.defaultId): Observable<Toaster> {
    return this.subject.asObservable().pipe(filter(x => x && x.id === id));
  }

  toast(type: ToastType, message: string) {
    this.subject.next(new Toaster({
      id: 'default',
      type,
      message,
      progress: 0
    }));
  }
}
